import React from "react";
import BasePaywall from "app/components/paywalls/BasePaywall";
import proIcon from "app/images/paywall-body-icon-pro.png";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type PropsDef = {
  show?: boolean;
  onClose?: () => void;
};

export default function UpgradeToProPaywall({ show, onClose }: PropsDef) {
  const { t } = useTranslation();

  const upperContent = (
    <p className={styles.description}>
      {t("Upgrade to")}{" "}
      <a href="https://coachnow.io/pro" className={styles.highlight}>
        CoachNow PRO
      </a>{" "}
      {t(
        "to access all new features, including Post Scheduling, Advanced Group Controls, and access to the ConnectedCoach Blueprint.",
      )}
    </p>
  );

  return (
    <BasePaywall
      show={show}
      onClose={onClose}
      title="Upgrade to CoachNow PRO"
      image={proIcon}
      imageClassname={styles.image}
      returnUrl="/spaces"
      featureName="Space Limit"
      upperContent={upperContent}
    />
  );
}
